Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var actions_1 = require("./actions");
var types_1 = require("./types");
exports.triggerNotificationEpic = function (action$) {
    return action$.ofType(types_1.NotificationsActionTypes.TRIGGER_NOTIFICATION)
        .pipe(operators_1.mergeMap(function (_a) {
        var notification = _a.payload.notification;
        if (notification.ttl === undefined)
            return rxjs_1.EMPTY;
        return rxjs_1.of(actions_1.closeNotification(notification.id)).pipe(operators_1.delay(notification.ttl));
    }));
};
exports.notificationsEpic = redux_observable_1.combineEpics(exports.triggerNotificationEpic);
